$milis_skills_skill_card $mol_card
	skill $milis_skills_skill
		name? => name?
		type? => type? \Без типа
	event *
		click? <=> skill_use? null
	content /
		<= Skill_title $mol_list rows /
			<= Skill_type $mol_string
				hint \Тип
				value? <=> type?
				enabled <= skill_edit_checked
			<= Skill_name $mol_string
				hint \Имя
				value? <=> name?
				enabled <= skill_edit_checked
		<= Skill_global_level $mol_pop_over
			Anchor <= Skill_global_level_text $mol_text text <= global_level_text \
			bubble_content /
				<= Skill_statistics $mol_text text <= skill_statistics \Использований 15
		<= Skill_info $mol_list rows <= skill_info_rows /
			<= Skill_description $mol_textarea
				hint \Описание
				value? <=> skill_description? \
				enabled <= skill_edit_checked
			<= Skill_mod_list $mol_list rows <= skill_mod_list /
				<= Skill_mod*0 $milis_skills_mod_input
					mod <= get_skill_mod* $milis_skills_mod
					skill <= skill
					skill_edit_checked <= skill_edit_checked
			<= Mod_add $mol_button_minor
				title \+ модификация
				click? <=> add_skill_mod? null
		<= Skill_meta $mol_row sub /
			<= Skill_edit_checkbox $mol_check_icon
				Icon <= Checked_icon $mol_icon_pencil
				checked? <=> skill_edit_checked? false
			<= Skill_id_copy $mol_button_copy
				title <= skill_id \
			<= Skill_remove $mol_button_minor
				sub / <= Remove_icon $mol_icon_delete 
				click? <=> skill_remove? null

$milis_skills_skill_card_textarea $mol_textarea
	attr *
		^
		mod_disabled_by_level <= mod_disabled_by_level true
